module.exports = __webpack_public_path__ + "img/filters.44b5c0fa.svg";